<template>
    <slider-with-input
        v-if="settingsAreAvailable"
        :value="investmentHorizon"
        :input-formatter="inputFormatter"
        :min="minInvestmentHorizon"
        :max="maxInvestmentHorizon"
        :max-slider="maxInvestmentHorizon"
        :input-suffix="getYearSingularOrPlural(investmentHorizon)"
        :text="$t('investmentGoals.investmentHorizon.text', { years: this.investmentHorizon })"
        :textleft="minInvestmentHorizon + getYearSingularOrPlural(minInvestmentHorizon)"
        :textright="maxInvestmentHorizon + getYearSingularOrPlural(maxInvestmentHorizon)"
        :mobile-text="$t('investmentGoals.investmentHorizon.mobile.years')"
        :force-numeric-keyboard="true"
        @valueChange="$emit('onInvestmentHorizonChange', $event)"
        @valueChangeConfirmed="$emit('onInvestmentHorizonChangeConfirmed', $event)" />
</template>

<script>
import SliderWithInput from '@/components/common/SliderWithInput';
import { mapGetters } from 'vuex';

export default {
    name: 'InvestmentGoalsHorizon',
    components: {
        SliderWithInput,
    },
    props: {
        investmentHorizon: {
            type: Number,
            required: false,
            default: null,
        },
    },
    computed: {
        ...mapGetters(['minInvestmentHorizon', 'maxInvestmentHorizon']),
        inputFormatter () {
            return {
                thousands: '’',
                suffix: this.getYearSingularOrPlural(this.investmentHorizon),
            };
        },
        settingsAreAvailable () {
            return this.minInvestmentHorizon !== null && this.maxInvestmentHorizon !== null;
        },
    },
    methods: {
        getYearSingularOrPlural (numberOfYears) {
            return numberOfYears > 1 ? ' ' + this.$t('investmentGoals.investmentHorizon.years')
                : ' ' + this.$t('investmentGoals.investmentHorizon.year');
        },
    },
};

</script>
